export default __webpack_public_path__ + "static/media/leaves.30c1cfb9.svg";